import { useState } from "react";
import { message } from "antd";

import { Dialog, DialogTitle, DialogActions } from "V2.0/common/dialog";
import { Button } from "V2.0/common/button";
import { showErrorToast } from "V2.0/utils";

export default BulkCampaignCancel;

interface BulkCampaignCancelProps {
  onClose: () => void;
  bulkCampaign: any;
  onBulkCampaignCancel: (
    bulkCampaignId: string,
    lifecycleCbs: {
      init: () => void;
      success: () => void;
      error: (e: any) => void;
    },
  ) => void;
}

function BulkCampaignCancel(props: BulkCampaignCancelProps) {
  const { onClose, onBulkCampaignCancel, bulkCampaign } = props;

  const [loading, setLoading] = useState<boolean>(false);

  const handleYes = () => {
    const init = () => {
      setLoading(true);
      message.loading(`Cancelling ${bulkCampaign.name}`);
    };

    const success = () => {
      setLoading(false);
      message.destroy();
      message.success(`${bulkCampaign.name} Cancelled`);
      onClose();
    };

    const error = (e: any) => {
      setLoading(false);
      message.destroy();
      showErrorToast(e, `Failed to cancel ${bulkCampaign.name}`);
    };

    onBulkCampaignCancel(bulkCampaign._id, { init, success, error });
  };

  const title = `Cancel "${bulkCampaign.name}" ?`;

  return (
    <Dialog
      open={true}
      onClose={onClose}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogActions>
        <Button
          outline
          onClick={onClose}
        >
          No
        </Button>
        <Button
          disabled={loading}
          onClick={handleYes}
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
}
